import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from './translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Clear any existing language preference and always start with Hindi
    localStorage.removeItem('language');
    return 'hi';
  });

  const [currentTranslations, setCurrentTranslations] = useState(() => {
    return translations[language] || translations['hi'];
  });

  useEffect(() => {
    // Update translations when language changes
    setCurrentTranslations(translations[language] || translations['hi']);
    // Save to localStorage
    localStorage.setItem('language', language);
  }, [language]);

  const t = (key) => {
    return currentTranslations[key] || key;
  };

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'hi' : 'en');
  };

  const value = {
    language,
    setLanguage,
    t,
    toggleLanguage,
    translations: currentTranslations
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
